import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';

export const CustomerTransferCompleted: React.FC = (): React.ReactElement => {
  const tr = useTranslator();
  const navigate = useNavigate();
  const { beneficiaryId = '' } = useParams<{ readonly beneficiaryId: string }>();

  const goToCustomerDetails = React.useCallback((): void => {
    navigate(`/accounts/${beneficiaryId}`);
  }, [navigate, beneficiaryId]);

  return (
    <ApplicationModal
      variant="prominent"
      title={tr('WE_RECEIVED_PAYMENT_INITIATED')}
      description={tr('WE_RECEIVED_PAYMENT_INITIATED_DESCRIPTION')}
      onClose={goToCustomerDetails}>
      <Button variant="dark" fullWidth={true} onClick={goToCustomerDetails}>
        {tr('DONE')}
      </Button>
    </ApplicationModal>
  );
};
